// go-chat-duplication
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, model } from '@angular/core';

import { GoNotificationStateService } from '@shared/services/go-notifications';
import { GoDashboardNotification } from '../go-dashboard-notification';
import { MatMenuItem } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { MatIcon } from '@angular/material/icon';
import { ConvertDateToTimePipe } from '../../../../../../shared/pipes/convert-date-to-time.pipe';

@Component({
  selector: 'app-go-primary-notification',
  templateUrl: './go-primary-notification.component.html',
  styleUrl: './go-primary-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatMenuItem, RouterLink, MatIcon, ConvertDateToTimePipe],
})
export class GoPrimaryNotificationComponent {
  private notificationStateService = inject(GoNotificationStateService);
  readonly notification = model<GoDashboardNotification>();

  public async notificationClicked(): Promise<void> {
    const notification = this.notification();
    if (notification.readAtTime == null) {
      await this.notificationStateService.markChatRequestNotificationsAsRead(notification.id);
    }
  }
}
